import React from 'react';
import './TopProgressBar.css';

export interface TopProgressBarProps {
  // No props needed for the simple header
}

const TopProgressBar: React.FC<TopProgressBarProps> = () => {
  return (
    <div className="top-header-bar">
      {/* Logo - Exact Figma Specifications */}
      <div className="header-logo">
        {/* Vector Icon - positioned at x: 0, y: 4.52px, size: 22.61x22.61px */}
        <svg
          className="header-logo-icon"
          width="22.61"
          height="22.61"
          viewBox="0 0 23 23"
          fill="none"
        >
          <path d="M11.5 0L14.4282 8.5718L23 11.5L14.4282 14.4282L11.5 23L8.5718 14.4282L0 11.5L8.5718 8.5718L11.5 0Z" fill="#FC6C29" />
        </svg>
        {/* Text "dayli" - positioned at x: 27.13px, y: 0, size: 64x30px */}
        <span className="header-logo-text">dayli</span>
      </div>
    </div>
  );
};

export default TopProgressBar; 